export enum ProductsStatus {
    GENERATED = 'GENERATED',
    ISSUED = 'ISSUED',
    APPLIED = 'APPLIED',
    INTRODUCED = 'INTRODUCED',
    SOLD = 'SOLD',
    DROPOUT = 'DROPOUT',
    AGGREGATED = 'AGGREGATED',
    DISAGGREGATED = 'DISAGGREGATED',
    PARSED_FROM_PHOTO = 'PARSED_FROM_PHOTO',
    RETURNED = 'RETURNED',
    UTILISATION = 'UTILISATION',
    ANNULLED = 'ANNULLED',
    SALE_BY_INVOICE = 'SALE_BY_INVOICE',
    RECEIVED_BY_INVOICE = 'RECEIVED_BY_INVOICE',
    MOVED_BY_INVOICE = 'MOVED_BY_INVOICE',
    IMPORTED = 'IMPORTED',
    DEPARENTED = 'DEPARENTED',
    PARENTED = 'PARENTED',
}

export enum ProductsPackageType {
    BOX = 'BOX',
    BLOCK = 'BLOCK',
    PALLET = 'PALLET',
}

export enum OrderStatus {
    APPROVED = 'APPROVED',
    READY = 'READY',
    DECLINED = 'DECLINED',
    CLOSED = 'CLOSED',
}

export enum OrderTypes {
    LOCAL = 'LOCAL',
    IMPORT = 'IMPORT',
}

export enum DocumentStatus {
    CREATED = 'CREATED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSED = 'PROCESSED',
    DRAFT = 'DRAFT',

    IN_PROGRESS = 'IN_PROGRESS',
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    NEW = 'NEW',
}

export enum DocumentType {
    AGGREGATE = 'AGGREGATE',
    AGGREGATED = 'AGGREGATED',
    APPLIED = 'APPLIED',
    DROPOUT = 'DROPOUT',
    GENERATED = 'GENERATED',
    INTRODUCE = 'INTRODUCE',
    ISSUED = 'ISSUED',
    UTILISATION = 'UTILISATION',
    DISAGGREGATED = 'DISAGGREGATED',
    RETURNED = 'RETURNED',
    UPD = 'UPD',
    SOLD = 'SOLD',
    SALE_BY_INVOICE = 'SALE_BY_INVOICE',
    RECEIVED_BY_INVOICE = 'RECEIVED_BY_INVOICE',
    MOVED_BY_INVOICE = 'MOVED_BY_INVOICE',
    IMPORTED = 'IMPORTED',
    DEPARENTED = 'DEPARENTED',
    PARENTED = 'PARENTED ',
    ANNULLED = 'ANNULLED',
}

export enum DocumentTypeEntity {
    AGGREGATE = 'AGGREGATE',
    DROPOUT = 'DROPOUT',
    INTRODUCE = 'INTRODUCE',
    UTILISATION = 'UTILISATION',
    UPD = 'UPD',
    MOVING = 'MOVING',
}

export enum CheckStatus {
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',

    NEW = 'NEW',
    CLOSED = 'CLOSED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

export enum GdsStatus {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    REVIEW = 'REVIEW',
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
    REJECTED_AUTOMATIC = 'REJECTED_AUTOMATIC',
}

export enum ReceiptType {
    INCOME = 'INCOME',
    RETURN = 'RETURN',
}

export enum ReceiptStatus {
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    CREATED = 'CREATED',
    PROCESSED = 'PROCESSED',
}

export enum AuthenticStatus {
    'AUTHENTIC' = 'AUTHENTIC',
    'COUNTERFEIT' = 'COUNTERFEIT',
    // 'DUBIOUS' = 'DUBIOUS',
}

export enum AuthenticDetectionContext {
    RETAIL_SALES = 'RETAIL_SALES',
    MANUAL = 'MANUAL',
}
